module.exports = {
      id: "action-usage",
      viewBox: "0 0 22.626 18.6",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#action",
      toString: function () {
        return this.url;
      }
    }